import { AboutDialogActions } from "../reducers/aboutdialog";

export const { openDialog, closeDialog } = AboutDialogActions;
